import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ec0fe28")

_pushScopeId("data-v-8ec0fe28")
const _hoisted_1 = { class: "fixed-box" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "票价：", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "separator1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "item" }, [
  /*#__PURE__*/_createVNode("span", null, "机建费："),
  /*#__PURE__*/_createVNode("div", { class: "separator2" }),
  /*#__PURE__*/_createVNode("span", null, " ￥30/人")
], -1)
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "保险费：", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "separator2" }, null, -1)
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, " 成人数：", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "separator3" }, null, -1)
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "儿童数(半价)：", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "separator4" }, null, -1)
const _hoisted_15 = { class: "total" }
const _hoisted_16 = /*#__PURE__*/_createVNode("b", null, "总计：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("span", null, " ￥" + _toDisplayString(_ctx.price) + "/人", 1)
    ]),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createVNode("span", null, " ￥" + _toDisplayString(_ctx.insuranceTotalPrice), 1)
    ]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _hoisted_11,
      _createVNode("span", null, _toDisplayString(_ctx.adultAmount), 1)
    ]),
    _createVNode("div", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _createVNode("span", null, _toDisplayString(_ctx.childAmount), 1)
    ]),
    _createVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode("span", null, "￥" + _toDisplayString(_ctx.getTotalPrice), 1)
    ])
  ]))
})